<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{$t('report_expense_summary')}} [{{title}}]</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)">
                <i class="fa fa-arrow-circle-o-left"></i>
                {{ $t('back') }}
            </button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onPrint">
                <i class="fa fa-print"></i>
                {{$t('print')}}
            </button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="exportExcel">
                <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                {{$t('export_excel')}}
            </button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <div style="display: flex; gap: 8px;">
                                <button type="button" class="btn btn-outline-primary btn-sm" :class="{active:section==1}" @click="onSection(1, $t('expense_summary'))"><i class="fa fa-line-chart" aria-hidden="true"></i> {{$t('expense_summary')}}</button>
                                <button type="button" class="btn btn-outline-primary btn-sm" :class="{active:section==2}" @click="onSection(2, $t('expense_on_cost'))"><i class="fa fa-download" aria-hidden="true"></i> {{$t('expense_on_cost')}}</button>
                                <button type="button" class="btn btn-outline-primary btn-sm" :class="{active:section==3}" @click="onSection(3, $t('expense_on_operation'))"><i class="fa fa-opera" aria-hidden="true"></i> {{$t('expense_on_operation')}}</button>
                                <button type="button" class="btn btn-outline-primary btn-sm" :class="{active:section==4}" @click="onSection(4, $t('expense_on_sale_return'))"><i class="fa fa-random" aria-hidden="true"></i> {{$t('expense_on_sale_return')}}</button>
                                <button type="button" class="btn btn-outline-primary btn-sm" :class="{active:section==5}" @click="onSection(5, $t('expense_monthly'))"><i class="fa fa-clock-o" aria-hidden="true"></i> {{$t('expense_monthly')}}</button>
                                <button type="button" class="btn btn-outline-primary btn-sm" :class="{active:section==6}" @click="onSection(6, $t('expense_yearly'))"><i class="fa fa-calendar" aria-hidden="true"></i> {{$t('expense_yearly')}}</button>
                            </div>
                        </div>
                    </div>
                    <br>
                    <keep-alive>
                        <component :is="currentTabComponent" @change="onChange"></component>
                    </keep-alive>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import SummarySection from './SummarySection.vue';
    import OperationSection from './OperationSection.vue';
    import ReturnSection from './ReturnSection.vue';
    import CostSection from './CostSection.vue';
    import MonthlySection from './MonthlySection.vue';
    import YearlySection from './YearlySection.vue';
    export default {
        components: {
            'section_1': SummarySection,
            'section_2': CostSection,
            'section_3': OperationSection,
            'section_4': ReturnSection,
            'section_5': MonthlySection,
            'section_6': YearlySection,
        },
        data(){
            return {
                section: 1,
                title: this.$t('expense_summary'),
                filter1: {},
                filter2: {},
                filter3: {},
                filter4: {},
                filter5: {},
                filter6: {},
            }
        },
        methods: {
            onSection(n, text){
                this.section = n;
                this.title = text;
            },
            onPrint(){
                let link = '';
                if(this.section == 1){
                    link = '/print-expense-summary?year='+this.filter1.Year+'&month=' + this.filter1.Month;
                }else if(this.section == 2){
                    link = '/print-expense-cost?year='+this.filter2.Year+'&month=' + this.filter2.Month;
                }else if(this.section == 3){
                    link = '/print-expense-operation?year='+this.filter3.Year+'&month=' + this.filter3.Month;
                }else if(this.section == 4){
                    link = '/print-expense-return?year='+this.filter4.Year+'&month=' + this.filter4.Month;
                }else if(this.section == 5){
                    link = '/print-expense-monthly';
                }else if(this.section == 6){
                    link = '/print-expense-yearly';
                }
                window.open(link, '_blank');
            },
            exportExcel() {
                let link = '';
                let fileName = '';
                let loading = this.$loading.show();
                const query = {
                    Year: '',
                    Month: ''
                };
                if(this.section === 1){
                    link = 'report/expense/summaries/export/excel';
                    fileName = 'report-expense-summaries.xlsx';
                    query.Year = this.filter1.Year;
                    query.Month = this.filter1.Month;
                }else if(this.section === 2){
                    link = 'report/expense/cost/export/excel';
                    fileName = 'report-expense-cost.xlsx';
                    query.Year = this.filter2.Year;
                    query.Month = this.filter2.Month;
                }else if(this.section === 3){
                    link = 'report/expense/operations/export/excel';
                    fileName = 'report-expense-operations.xlsx';
                    query.Year = this.filter3.Year;
                    query.Month = this.filter3.Month;
                }else if(this.section === 4){
                    link = 'report/expense/returns/export/excel';
                    fileName = 'report-expense-returns.xlsx';
                    query.Year = this.filter4.Year;
                    query.Month = this.filter4.Month;
                }else if(this.section === 5){
                    link = 'report/expense/monthly/export/excel';
                    fileName = 'report-expense-monthly.xlsx';
                    query.Year = this.filter5.Year;
                    query.Month = this.filter5.Month;
                }else if(this.section === 6){
                    link = 'report/expense/yearly/export/excel';
                    fileName = 'report-expense-yearly.xlsx';
                    query.Year = this.filter6.Year;
                    query.Month = this.filter6.Month;
                }
                this.$api()({
                    url: this.$base() + link,
                    method: 'post',
                    data: query,
                    responseType: 'blob'
                }).then(res => {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                }).finally(function(){ loading.hide();});
            },
            onChange(sender, evt){
                if(sender == 1){
                    this.filter1 = evt;
                }else if(sender == 2){
                    this.filter2 = evt;
                }else if(sender == 3){
                    this.filter3 = evt;
                }else if(sender == 4){
                    this.filter4 = evt;
                }
            }
        },
        computed: {
            currentTabComponent(){
                return 'section_' + this.section;
            }
        }
    }
</script>
